import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getOffers } from '../../../../../redux/actions/offers'
import { getTags } from '../../../../../redux/actions/tags'
import { IRootState } from '../../../../../redux/types'

export const useOffersFilters = () => {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const { globalFamilyId, globalBrandId, globalLineId, globalCountriesId, globalLanguageId } = useSelector(
    (state: IRootState) => state.global
  )
  const { tags } = useSelector((state: IRootState) => state.tag)
  const { reload } = useSelector((state: IRootState) => state.offer)

  const status = [
    { id: 0, name: 'Activo' },
    { id: 1, name: 'Inactivo' }
  ]
  const visibility = [
    { id: 0, name: t('close') },
    { id: 1, name: 'VIP' }
  ]
  const optionsData = [
    { data: status, code: 'status', column: 'status' },
    { data: visibility, code: 'visibility', column: 'visibility' },
    { data: tags, code: 'categories', column: 'tag_id' }
  ]

  useEffect(() => {
    if (tags.length === 0) dispatch(getTags())
  }, [])

  useEffect(() => {
    if (reload) {
      fetchOffers()
    }
  }, [reload])

  useEffect(() => {
    if (globalLanguageId !== null && globalCountriesId.length > 0) {
      fetchOffers()
    }
  }, [globalFamilyId, globalBrandId, globalLineId, globalLanguageId, globalCountriesId])

  const fetchOffers = (filterOptions?: any) => {
    dispatch(
      getOffers({
        family_id: globalFamilyId,
        brand_id: globalBrandId,
        line_id: globalLineId,
        language_id: globalLanguageId,
        countries: globalCountriesId,
        ...(filterOptions && { filterBy: filterOptions })
      })
    )
  }

  const handleClickSetOptions = (options: any) => {
    fetchOffers(options)
  }

  return {
    optionsData,
    globalBrandId,
    handleClickSetOptions
  }
}
